module.exports = __webpack_public_path__ + "img/电梯动画17.6e32027e.png";